import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
export default function Home(){
  return (
    <div className="home-page">
      <section className="hero enhanced">
        <motion.div className="hero-bg" initial={{opacity:0}} animate={{opacity:1}} transition={{duration:1}}>
          <img src="/assets/stock_coupe.svg" alt="background coupe" className="hero-bg-img" />
        </motion.div>
        <motion.div initial={{opacity:0, y:10}} animate={{opacity:1, y:0}} transition={{duration:0.8}} className="hero-inner">
          <div className="hero-logo">
            <img src="/assets/451CB2E7-479A-479A-AE58-C7205158FF25 (1).PNG" alt="steamers logo" />
          </div>
          <h1>Now Opening 2027 — Steamers Auto</h1>
          <p className="tag">Used Cars • Detailing • Leasing • Financing</p>
          <div className="hero-ctas">
            <Link to="/cars" className="btn primary">Shop Cars</Link>
            <Link to="/detailing" className="btn">Book Detailing</Link>
            <Link to="/contact" className="btn">Get Financing</Link>
          </div>
        </motion.div>
      </section>
      <section className="services section">
        <h2>Our Services</h2>
        <div className="services-grid">
          <div className="service-card">Used Cars</div>
          <div className="service-card">Professional Detailing</div>
          <div className="service-card">Rideshare Leasing</div>
          <div className="service-card">In-house Financing</div>
        </div>
      </section>
      <section className="gallery-preview section">
        <h2>Recent Work</h2>
        <div className="gallery-row">
          <img src="/assets/IMG_4904.jpg" alt="detail1" />
          <img src="/assets/IMG_4817.jpg" alt="detail2" />
        </div>
      </section>
    </div>
  );
}